import { Chain } from '@ankr.com/chains-list';

import { Dialog } from 'uiKit/Dialog';
import { JWT } from 'domains/jwtToken/types';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';
import { EndpointsContainer } from 'modules/chains/components/EndpointsContainer';

import { ChainSelectors } from '../ChainSelectors';
import { ChainSelectorsProvider } from '../ChainSelectorsProvider';
import { TokenSelector } from './components/TokenSelector/TokenSelector';
import { endpointModalTranslation } from './translation';
import { useCopyEndpointModalStyles } from './useCopyEndpointModalStyles';
import { ChainDescription } from '../ChainDescription';

const onDialogClick = (event: React.MouseEvent) => event.stopPropagation();

interface ICopyEndpointModalProps {
  chain: Chain;
  currentProjectIndex: number;
  hasConsensusSwitch?: boolean;
  hasProjectSelector?: boolean;
  isOpened: boolean;
  jwtTokens: JWT[];
  onClickCloseButton: () => void;
  userEndpointToken: string;
}

// we are merging extensions for custom endpoints to show them on one page without selectors
const SHOULD_MERGE_EXTENSIONS = true;

export const CopyEndpointModalContent = ({
  chain,
  currentProjectIndex,
  hasConsensusSwitch = true,
  hasProjectSelector,
  isOpened,
  jwtTokens,
  onClickCloseButton,
  userEndpointToken,
}: ICopyEndpointModalProps) => {
  const { keys, t } = useTranslation(endpointModalTranslation);

  const { classes } = useCopyEndpointModalStyles();

  return (
    <ChainSelectorsProvider
      chain={chain}
      hasConsensusSwitch={hasConsensusSwitch}
      shouldSkipChainTypeReset={true}
      shouldMergeExtensions={SHOULD_MERGE_EXTENSIONS}
    >
      <Dialog
        onClick={onDialogClick}
        onClose={onClickCloseButton}
        open={isOpened}
        paperClassName={classes.endpointsDialog}
        shouldStopPropagationOnClose
        title={t(keys.copyEndpoint)}
      >
        <ChainDescription
          chain={chain}
          logoSize={40}
          isCompactView
          className={classes.chainDescription}
        />
        {hasProjectSelector && (
          <TokenSelector
            jwtTokens={jwtTokens}
            currentProjectIndex={currentProjectIndex}
          />
        )}
        <ChainSelectors className={classes.chainSelectors} />
        <EndpointsContainer userEndpointToken={userEndpointToken} />
      </Dialog>
    </ChainSelectorsProvider>
  );
};
